'use client';
import { useEffect } from 'react';
import { ToastContainer } from '@bfe/moly';
import { Faq } from './components/Faq';
import { Banner } from './components/Banner';
import { ListContent } from './components/List';
import { Guide } from './components/Guide';
import { GuideModal } from "./components/ModelContainerWrapper/guide"
import { useMarket } from '@/store/market';
import ThemeProvider from '@/config/themeProvider';
import {
  AvailableCoinsClick,
} from '@/config/sensor';

export default function Index() {
  const store = useMarket();
  const tabName = store.currentTabName

  useEffect(() => {
    AvailableCoinsClick()
    store.init()
    // store.fetchTokenList(tabName);
    store.fetchTokenListAvaliable()
    store.fetchTradeCount()
  }, []);

  return (
    <ThemeProvider>
      <ToastContainer />
      <Banner />
      <ListContent />
      <Guide />
      <GuideModal />
      <Faq />
    </ThemeProvider>
  );
}
